function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconPromotionPointRewardRexOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M12.88 24.32l-5.29 5.3-1-5-5-1 4.15-4.14a12 12 0 007.14 4.84zm2.71-19.7a8 8 0 110 16 8 8 0 010-16zm0-2a10 10 0 100 20 10 10 0 000-20zm14 21l-5 1-1 5-5.3-5.3a12.06 12.06 0 007.15-4.84l4.15 4.14zM13.23 17V8.56h2.83a4.28 4.28 0 011.78.34c.48.211.887.559 1.17 1a2.78 2.78 0 01.41 1.55A2.73 2.73 0 0119 13a2.76 2.76 0 01-1.17 1c-.564.234-1.17.35-1.78.34H15V17h-1.77zM16 10.11h-1v2.6h1a2.08 2.08 0 001.18-.3 1.1 1.1 0 00.45-1 1.131 1.131 0 00-.45-1 2.08 2.08 0 00-1.18-.3z",
    fill: props.color
  }));
}

export default SvgIconPromotionPointRewardRexOutline;